export const REGEX = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};

export const LOGIN_FORM = {
  EMAIL: {
    name: "userName" /* To the controller component for the unique identity */,
    type: "text" /*To the controller component for selecting the field type */,
    rules: {
      required: true,
      pattern: {
        value: REGEX.EMAIL,
        message: "Email is invalid",
      },
    } /*To the controller component for providing the field rules, */,
    label:
      "email" /*To the controller component for providing the field label, */,
    disabled: false /*To the dynamic field for disabling purposes*/,
    defaultValue: "" /*To the dynamic field for rendering the default value,*/,
  },
  PASSWORD: {
    name: "password",
    type: "password",
    rules: { required: true },
    label: "password",
    disabled: false,
    defaultValue: "",
  },
  LOGIN_BUTTON: {
    type: "submit",
    label: "login",
    variant: "contained",
  },
};
export const SEARCH_FLIGHT_SHOP_FORM = {
  FROM: {
    name: "from",
    type: "search",
    rules: { required: true },
    nolabel: true,
    disabled: false,
    defaultValue: "",
    placeholder: "Select Origin",
  },
  TO: {
    name: "to",
    type: "search",
    rules: { required: true },
    nolabel: true,
    disabled: false,
    defaultValue: "",
    placeholder: "Select Destination",
  },
  SEARCH_BUTTON: {
    type: "submit",
    label: "search",
    variant: "contained",
  },
};

export const ADD_FIGHT_SHOP_FORM = {
  // form 1
  YOUR_AIRLINE: {
    name: "yourairline",
    type: "checkbox",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  PICK_BRANDS: {
    name: "pickbrands",
    type: "checkbox",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  PICK_GDS: {
    name: "pickgds",
    type: "checkbox",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  PICK_OTAS: {
    name: "pickotas",
    type: "checkbox",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  PICK_OTHER_SOURCES: {
    name: "pickothersources",
    type: "checkbox",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  PICK_RATE_PARITY_DATA: {
    name: "rateparity",
    type: "checkbox",
    nolabel: true,
    disabled: false,
    defaultValue: false,
  },
  VOLATILITY_DATA: {
    name: "volatilitydata",
    type: "checkbox",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  SELECTED_VOLATILITY_AIRLINE: {
    name: "selectedVolotilityAirline",
    type: "select",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },

  // form 2
  ROUTE_TYPE: {
    name: "routetype",
    type: "radio",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    options: ["OW", "RT"],
  },
  LOS: {
    name: "los",
    type: "text",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  CABIN_CLASS: {
    name: "cabinclass",
    type: "radio",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    options: ["Economy", "Business", "First Class", "Premium Economy"],
  },
  ADULTS: {
    name: "adults",
    type: "number",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    max: 5,
    min: 1,
  },
  INFANTS: {
    name: "infants",
    type: "number",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    max: 5,
    min: 1,
  },
  POS: {
    name: "pos",
    type: "select",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  CURRENCY: {
    name: "currency",
    type: "select",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  MAXSTOPS: {
    name: "maxStops",
    type: "select",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  }, 
   MAXDURATION: {
    name: "maxDuration",
    type: "select",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  PRICEEVOLUTION: {
    name: "priceevolution",
    type: "select",
    nolabel: true,
    disabled: false,
    options: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "60"],
    defaultValue: "0",
    noSelect: true
  },

  CUSTOM_HORIZON: {
    name: "customhorizon",
    type: "text",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    max: 365,
    min: 0,
  },
  DAYS_OUT: {
    name: "daysout",
    type: "select",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    options: [
      "1 Day",
      "2 Days",
      "3 Days",
      "7 Days",
      "14 Days",
      "30 Days",
      "45 Days",
      "60 Days",
      "90 Days",
      "120 Days",
      "180 Days",
      "365 Days",
    ],
  },
  HORIZON_START_DAY: {
    name: "horizonstartday",
    type: "number",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    max: 365,
    min: 0,
  },
  HORIZON_END_DAY: {
    name: "horizonendday",
    type: "number",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    max: 365,
    min: 0,
  },
  HORIZON_START_DATE: {
    name: "horizonstartdate",
    type: "date",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    placeholder: "Select Start Date",
  },
  HORIZON_END_DATE: {
    name: "horizonenddate",
    type: "date",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    placeholder: "Select End Date",
  },
  // form 3
  REFRESH_FREQUENCY: {
    name: "refreshfrequency",
    type: "radio",
    nolabel: true,
    disabled: false,
    defaultValue: "Daily",
    options: ["Daily", "Weekly", "Monthly", "Custom"],
  },
  DELIVERY_TIME: {
    name: "deliverytime",
    type: "time",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  TIME_ZONE: {
    name: "timezone",
    type: "search",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    placeholder: "Select Time Zone",
  },
  FLIGHT_SHOP_START_DATE: {
    name: "flightshopstartdate",
    type: "date",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    placeholder: "Select Start Date",
  },
  FLIGHT_SHOP_END_DATE: {
    name: "flightshopenddate",
    type: "date",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    placeholder: "Select End Date",
  },
  SPECIFY_END_DATE: {
    name: "specifyenddate",
    type: "radio",
    nolabel: true,
    disabled: false,
    defaultValue: "No",
    options: ["Yes", "No"],
  },
  FLIGHT_SHOP_NAME: {
    name: "flightshopname",
    type: "text",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  PICK_YOUR_WEEKLY_DAYS: {
    name: "pickyourweeklydays",
    type: "checkbox",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    options: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
  },
  PICK_YOUR_MONTHLY_DAYS: {
    name: "pickyourmonthlydays",
    type: "select",
    nolabel: true,
    disabled: false,
    placeholder: "Select",
    defaultValue: "",
    options: [
      "1st",
      "2nd",
      "3rd",
      "4th",
      "5th",
      "6th",
      "7th",
      "8th",
      "9th",
      "10th",
      "11th",
      "12th",
      "13th",
      "14th",
      "15th",
      "16th",
      "17th",
      "18th",
      "19th",
      "20th",
      "21st",
      "22nd",
      "23rd",
      "24th",
      "25th",
      "26th",
      "27th",
      "28th",
      "29th",
      "30th",
      "31st",
    ],
  },
  PRICEEVOLUTION_FREQUENCY: {
    type: "radio",
    name: "priceevloutionfrequency",
    options: ["Daily", "Weekly", "Monthly"],
    defaultValue: "Daily",
    nolabel: true
  },
  PRICE_EVOLUTION_PICK_YOUR_WEEKLY_DAYS: {
    name: "pickevolutionpickyourweeklydays",
    type: "checkbox",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    options: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
  },
  PRICE_EVOLUTION_PICK_YOUR_MONTHLY_DAYS: {
    name: "priceevolutionpickyourmonthlydays",
    type: "select",
    nolabel: true,
    disabled: false,
    placeholder: "Select",
    defaultValue: "",
    options: [
      "1st",
      "2nd",
      "3rd",
      "4th",
      "5th",
      "6th",
      "7th",
      "8th",
      "9th",
      "10th",
      "11th",
      "12th",
      "13th",
      "14th",
      "15th",
      "16th",
      "17th",
      "18th",
      "19th",
      "20th",
      "21st",
      "22nd",
      "23rd",
      "24th",
      "25th",
      "26th",
      "27th",
      "28th",
      "29th",
      "30th",
      "31st",
    ],
  },
  PRICE_EVOLUTION_DELIVERY_TIME: {
    name: "priceevolutiondeliverytime",
    type: "time",
    nolabel: true,
    disabled: false,
    defaultValue: "",
  },
  PRICE_EVOLUTION_TIME_ZONE: {
    name: "priceevolutiontimezone",
    type: "search",
    nolabel: true,
    disabled: false,
    defaultValue: "",
    placeholder: "Select Time Zone",
  },
};

export const MY_FLIGHT_SHOP_SEARCH_FORM = {
  FLIGHT_SHOP: {
    type: "text",
    name: "shopname",
    defaultValue: "",
    placeholder: "Name",
    nolabel: true
  },
  MARKET_FROM: {
    type: "search",
    name: "flyfrom",
    options: [],
    defaultValue: "",
    placeholder: "From",
    nolabel: true
  },
  MARKET_TO: {
    type: "search",
    name: "flyto",
    options: [],
    defaultValue: "",
    placeholder: "To",
    nolabel: true
  },
  FREQUENCY: {
    type: "checkbox",
    name: "frequency",
    options: [{ name: "Select Frequency", value: "" }, { name: "Daily", value: 1 }, { name: "Weekly", value: 2 }, { name: "Monthly", value: 3 }, { name: "Custom", value: 4 }],
    defaultValue: "",
    nolabel: true
  },
  FREQUENCY_DAYS: {
    type: "checkbox",
    name: "frequency_days",
    options: [{ name: "NONE", value: "" }, { name: "SUN", value: 0 }, { name: "MON", value: 1 }, { name: "TUE", value: 2 }, { name: "WED", value: 3 }, { name: "THU", value: 4 }, { name: "FRI", value: 5 }, { name: "SAT", value: 6 }],
    defaultValue: "",
    nolabel: true
  },
  POS: {
    type: "select",
    name: "pos",
    defaultValue: "",
    placeholder: "Select",
    nolabel: true
  },
  SOURCE: {
    type: "select",
    name: "source",
    defaultValue: "",
    placeholder: "Select",
    nolabel: true
  },
  HORIZON: {
    type: "select",
    name: "horizon",
    options: [
      "1 Day",
      "2 Days",
      "3 Days",
      "7 Days",
      "14 Days",
      "30 Days",
      "45 Days",
      "60 Days",
      "90 Days",
      "120 Days",
      "180 Days",
      "365 Days",
    ],
    defaultValue: "",
    placeholder: "Select",
    nolabel: true
  },
  OUTPUT_TYPE: {
    type: "select",
    name: "routetype",
    options: ["Data only", "Data and Charts"],
    defaultValue: "",
    placeholder: "Select",
    nolabel: true
  },
  ROUTE_TYPE: {
    type: "select",
    name: "routetype",
    options: [{ name: "One-way", value: 1 }, { name: "Round Trip", value: 2 }],
    defaultValue: "",
    placeholder: "Select",
    nolabel: true
  },
  SHOP_STATUS: {
    type: "select",
    name: "status",
    options: [{ name: "Active", value: 1 }, { name: "Deleted", value: 4 }, { name: "Paused", value: 2 }],
    defaultValue: "Active",
    noSelect: true,
    nolabel: true
  },
  CABIN_CLASS: {
    type: "select",
    name: "cabinclass",
    options: [{ name: "Economy", value: 1 }, { name: "Business", value: 2 },
    { name: "First Class", value: 3 }, { name: "Premium Economy", value: 4 }],
    defaultValue: "",
    placeholder: "Select",
    nolabel: true
  },
  CURRENCY: {
    type: "select",
    name: "currency",
    defaultValue: "",
    placeholder: "Select",
    nolabel: true
  },
};

export const VIEW_FLIGHT_SHOP_GROUP_FILTER_FORM = {
  GROUP_NAME: {
    type: "text",
    name: "gorupname",
    placeholder: "Name",
    defaultValue: "",
    nolabel: true,
  },
  MARKET_FROM: {
    type: "search",
    name: "marketfrom",
    placeholder: "From",
    defaultValue: "",
  },
  MARKET_TO: {
    type: "search",
    name: "marketto",
    placeholder: "To",
    defaultValue: "",
  },
};
